"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTh = exports.StyledTable = exports.StyledSortArrow = exports.StyledRow = exports.StyledHead = exports.StyledEditBox = exports.StyledCell = exports.CheckboxWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _shared = require("../../shared");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledTable = _styledComponents.default.table.withConfig({
  displayName: "Tablestyle__StyledTable",
  componentId: "sc-pqrr8-0"
})(["position:relative;table-layout:auto;width:100%;background:", ";text-align:left;box-sizing:border-box;border-collapse:collapse;", ";:before{content:", ";position:absolute;display:inline-flex;align-items:center;background:transparent;left:2px;bottom:calc(100% + 16px);font-size:14px;line-height:16px;color:", ";", ";}.child-row{border-left:1px solid ", ";border-right:1px solid ", ";}.child-cell{:first-child{padding-right:14px;}}.has-child{padding:0;}.expansion-cell{position:relative;width:60px !important;svg{position:absolute;left:50%;top:50%;transform-origin:50% 50%;transform:translate(-50%,-50%);transition:all 0.2s ease;}}.rotate-caret{transform:rotate(180deg);svg{path{fill:", ";}}}.hide{width:0;opacity:0;}"], _shared.theme.palette.brand.primary.white, ({
  borderRadius
}) => borderRadius && `border-radius:${borderRadius}`, ({
  caption
}) => caption && `'${caption}'`, _shared.theme.palette.brand.primary.charcoal, ({
  hideCaption
}) => hideCaption && `display:none`, _shared.theme.palette.ui.states.active, _shared.theme.palette.ui.states.active, _shared.theme.palette.ui.states.active);

exports.StyledTable = StyledTable;

const StyledHead = _styledComponents.default.thead.withConfig({
  displayName: "Tablestyle__StyledHead",
  componentId: "sc-pqrr8-1"
})(["border-radius:4px 4px 0px 0px;"]);

exports.StyledHead = StyledHead;

const StyledTh = _styledComponents.default.th.withConfig({
  displayName: "Tablestyle__StyledTh",
  componentId: "sc-pqrr8-2"
})(["position:relative;box-sizing:border-box;padding:32px 0px;font-size:13px;line-height:16px;letter-spacing:0.02em;color:", ";cursor:default;user-select:none;word-wrap:break-word;", ";", " &:last-child{padding-right:24px;}", " ", ""], _shared.theme.palette.brand.primary.gray, ({
  isSortable
}) => !isSortable && `
		pointer-events:none;
	`, ({
  sort
}) => (sort === '0' || sort === '1') && `
      color: ${_shared.theme.palette.brand.primary.charcoal} !important;
    `, ({
  showIndex,
  isCollapse
}) => showIndex && `
	&:first-child {
    ${showIndex && `width:70px`};
    ${!isCollapse && showIndex ? `text-align:center` : `text-align:left`};
	`, ({
  showIndex
}) => !showIndex && `
		&:first-child{
			padding-left:30px;
		}
	`);

exports.StyledTh = StyledTh;

const StyledRow = _styledComponents.default.tr.withConfig({
  displayName: "Tablestyle__StyledRow",
  componentId: "sc-pqrr8-3"
})(["", " box-shadow:inset 0px -1px 0px rgba(115,127,143,0.2);", " ", ":not(.table-main-row){:hover{background:", ";box-shadow:inset 0px -1px 0px ", ";}}"], ({
  isEditRow
}) => isEditRow && `height:70px;`, ({
  showOutline
}) => showOutline && `
		border:1px solid ${_shared.theme.palette.ui.states.active};
		border-bottom:none;
	`, ({
  isLastChild
}) => isLastChild && `
		border-bottom:1px solid ${_shared.theme.palette.ui.states.active};
	`, _shared.theme.palette.ui.neutral.grey5, _shared.theme.palette.ui.neutral.grey4);

exports.StyledRow = StyledRow;

const StyledCell = _styledComponents.default.td.withConfig({
  displayName: "Tablestyle__StyledCell",
  componentId: "sc-pqrr8-4"
})(["box-sizing:border-box;position:relative;font-size:", ";line-height:", ";letter-spacing:", ";color:", ";padding:25px 0px;&:first-child{text-align:", ";width:", ";padding-left:", ";}word-wrap:break-word;transition:all 0.2s ease;"], _shared.theme.typography.h6.fontSize, _shared.theme.typography.h6.lineHeight, _shared.theme.typography.h6.letterSpacing, _shared.theme.palette.brand.primary.charcoal, ({
  isSelectable,
  showIndex,
  shouldCenter
}) => isSelectable || showIndex || shouldCenter ? 'center' : 'left', ({
  showIndex
}) => showIndex && '70px', ({
  isCollapse,
  showIndex,
  isfooter
}) => !isCollapse && !showIndex && !isfooter ? '30px' : '0px');

exports.StyledCell = StyledCell;

const CheckboxWrapper = _styledComponents.default.span.withConfig({
  displayName: "Tablestyle__CheckboxWrapper",
  componentId: "sc-pqrr8-5"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);label{&:hover{background:none;}}"]);

exports.CheckboxWrapper = CheckboxWrapper;
const AscendingSortStyle = (0, _styledComponents.css)(["path{fill:", ";}"], _shared.theme.palette.brand.primary.charcoal);
const DescendingSortStyle = (0, _styledComponents.css)(["svg{transform:rotate(180deg);path{fill:", ";}}"], _shared.theme.palette.brand.primary.charcoal);
const sortArrowStyle = new Map();
sortArrowStyle.set('0', AscendingSortStyle);
sortArrowStyle.set('1', DescendingSortStyle);

const StyledSortArrow = _styledComponents.default.span.withConfig({
  displayName: "Tablestyle__StyledSortArrow",
  componentId: "sc-pqrr8-6"
})(["position:relative;padding:0 8px;svg{position:absolute;transform-origin:50% 50%;transition:all 0.2s ease;path{fill:", ";}", "}", ""], _shared.theme.palette.brand.primary.gray, ({
  sort
}) => (sort === '0' || sort === '1') && sortArrowStyle.get(sort), ({
  sort
}) => sort && sortArrowStyle.get(sort));

exports.StyledSortArrow = StyledSortArrow;

const StyledEditBox = _styledComponents.default.div.withConfig({
  displayName: "Tablestyle__StyledEditBox",
  componentId: "sc-pqrr8-7"
})(["position:absolute;top:50%;transform:translateY(-50%);padding-left:85px;display:inline-flex;align-items:center;.input-wrapper{display:inline-block;}.edit-input{display:inline-block;margin-right:11px;width:396px;height:40px;border:1px solid #0d62ff;border-radius:4px;", ";color:", ";}.success-btn{width:32px;height:32px;position:relative;top:2px;& > svg{position:absolute;transform:translateX(1px);width:14px;height:10px;}}.cancel-btn{width:32px;height:32px;margin-left:9px;:hover{svg > path{fill:", ";}}}"], _shared.theme.typography.h6.css, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.white);

exports.StyledEditBox = StyledEditBox;